export default "__VITE_ASSET__hVAIeMro__"